module.exports = __webpack_public_path__ + "img/logo-here.875ed470.png";